import { createFileRoute } from '@tanstack/react-router';

import { AdminCategoriesPage } from '@/components/admin/categories-page';
import { adminHead } from '@/lib/seo';
import { adminListCategoriesFn } from '@/server/functions/admin';

export const Route = createFileRoute('/_admin/admin/categories')({
    component: CategoriesRoute,
    head: () => adminHead('קטגוריות', '/admin/categories'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListCategoriesFn(),
});

function CategoriesRoute() {
    const data = Route.useLoaderData();
    return <AdminCategoriesPage initial={data} />;
}
